import Base from '@/parts/pages/base';
import Login from '@/parts/pages/login';
import Register from '@/parts/pages/register';
import Contract from '@/parts/pages/contract';
import Sign from '@/parts/pages/sign';
import Indication from '@/parts/pages/indication';
// import Dashboard from "@/parts/pages/client/index"
import Search from '@/parts/pages/client/vibbrants/search';
import Request from '@/parts/pages/client/vibbrants/request';
import Vibbrant from '@/parts/pages/client/vibbrants/vibbrant';
import Vibbrants from '@/parts/pages/client/vibbrants/vibbrants';
import Wallet from '@/parts/pages/client/wallet';
import Profile from '@/parts/pages/client/profile';
import RecoverPass from '@/parts/pages/recover-pass';
import NewPass from '@/parts/pages/new-pass';
import RegisterSuccess from '@/parts/pages/register-success';
import VibbranteProfile from '@/parts/pages/client/vibbrante-profile-page';
import AcceptClient from '@/parts/pages/accept-client';
import ClientReleaseRegister from '@/parts/pages/client-release-register';

import Terms from '@/parts/pages/terms';
import Privacy from '@/parts/pages/privacy';

export default {
  path: '/client',
  component: Base,
  meta: { requireAuth: true },
  children: [
    {
      path: 'login',
      name: 'client-login',
      component: Login,
      props: { profile: 'client' },
      meta: { requireAuth: false },
    },
    {
      path: 'register',
      name: 'client-register',
      component: Register,
      props: { profile: 'client' },
      meta: { requireAuth: false },
    },
    {
    path: 'registerTeste',
    name: 'client-registerTeste',
    component: Indication,
    props: { profile: 'client' },
    meta: { requireAuth: false },
  },
    {
      path: 'search',
      name: 'client-search',
      component: Search,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'search/vibbrante/:id',
      name: 'client-search-vibbrante',
      component: VibbranteProfile,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'search/request',
      name: 'client-search-request',
      component: Request,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'vibbrants/monitor/:id',
      name: 'client-vibbrant',
      component: Vibbrant,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'vibbrants/monitor/:id/:task',
      name: 'client-vibbrant-task',
      component: Vibbrant,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'vibbrants/contract/:id',
      name: 'client-contract',
      component: Contract,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'vibbrants',
      name: 'client-vibbrants',
      component: Vibbrants,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'vibbrants/active',
      name: 'client-vibbrants-active',
      component: Vibbrants,
      props: { profile: 'client', activeTab: 'active' },
      meta: { requireAuth: true },
    },
    {
      path: 'vibbrants/pending',
      name: 'client-vibbrants-pending',
      component: Vibbrants,
      props: { profile: 'client', activeTab: 'pending' },
      meta: { requireAuth: true },
    },
    {
      path: 'vibbrants/finalized',
      name: 'client-vibbrants-finalized',
      component: Vibbrants,
      props: { profile: 'client', activeTab: 'finalized' },
      meta: { requireAuth: true },
    },
    {
      path: 'vibbrants/credit-transfer',
      name: 'client-vibbrants-credit-transfer',
      component: Vibbrants,
      props: { profile: 'client', activeTab: 'credit-transfer' },
      meta: { requireAuth: true },
    },
    {
      path: 'wallet',
      name: 'client-wallet',
      component: Wallet,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'profile',
      name: 'client-profile',
      component: Profile,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'sign/:id/:vibbrante_id',
      name: 'client-sign',
      component: Sign,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },

    {
      path: '',
      name: 'client-dashboard',
      component: Vibbrants,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'recover-pass',
      name: 'client-recover-pass',
      component: RecoverPass,
      props: { profile: 'client' },
      meta: { requireAuth: false },
    },
    {
      path: 'new-pass',
      name: 'client-new-pass',
      component: NewPass,
      props: { profile: 'client' },
      meta: { requireAuth: false },
    },
    {
      path: 'register-success',
      name: 'client-register-success',
      component: RegisterSuccess,
      props: { profile: 'client' },
      meta: { requireAuth: false },
    },
    {
      path: 'accept-client',
      name: 'accept-client',
      component: AcceptClient,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'terms/:id',
      name: 'client-terms-signed',
      component: Terms,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'privacy/:id',
      name: 'client-privacy-signed',
      component: Privacy,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },
    {
      path: 'release-register',
      name: 'release-register',
      component: ClientReleaseRegister,
      props: { profile: 'client' },
      meta: { requireAuth: true },
    },

    // { path: 'login', name: 'client-login', component: Login, props: {profile: 'client'}, meta: {requireAuth: false} },
    // { path: 'register', name: 'client-register', component: Register, props: {profile: 'client'} },
    // { path: 'search', name: 'client-search', component: ClientSearch, meta: {requireAuth: true} },
    // { path: 'search/request', name: 'client-search-request', component: ClientRequest, meta: {requireAuth: true} },
    // { path: 'vibbrants/nome-do-vibbrant', name: 'client-vibbrant', component: ClientVibbrant, meta: {requireAuth: true} },
    // { path: 'vibbrants/nome-do-vibbrant/contract', name: 'client-contract', component: ClientContract, meta: {requireAuth: true} },
    // { path: 'vibbrants', name: 'client-vibbrants', component: ClientVibbrants, meta: {requireAuth: true} },
    // { path: 'wallet', name: 'client-wallet', component: ClientWallet, meta: {requireAuth: true} },
    // { path: 'profile', name: 'client-profile', component: ClientProfile, meta: {requireAuth: true} },
    // { path: 'sign', name: 'client-sign', component: ClientSign, meta: {requireAuth: true} },
    //
    // { path: '', name: 'client-dashboard', component: ClientVibbrants, meta: {requireAuth: true} }
  ],
};



// WEBPACK FOOTER //
// ./src/router/client.js